import React from "react";
import { SidebarProvider } from "../components/ui/sidebar";
import { AppSidebar } from "../components/AppSidebar";
import { TopBar } from "../components/TopBar";
import { Toaster } from "../components/ui/toaster";
import { useIsMobile } from "../hooks/use-mobile";
import { Analytics } from "@vercel/analytics/react";
import { FloatingActionButton } from "../components/shared/FloatingActionButton";

interface AppLayoutProps {
  children: React.ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const isMobile = useIsMobile();

  return (
    <SidebarProvider defaultOpen={!isMobile}>
      <div className="flex min-h-screen w-full bg-background">
        <div className="hidden md:block">
          <AppSidebar />
        </div>
        <div className="flex flex-col flex-1 w-full">
          <TopBar />
          <main className="flex-1 w-full">
            {children}
          </main>
        </div>
      </div>
      <FloatingActionButton />
      <Toaster />
      <Analytics />
    </SidebarProvider>
  );
}